export const adminKeys = {
    all: ['admin'],
    stats: () => [...adminKeys.all, 'stats'],
    works: () => [...adminKeys.all, 'works'],
    worksList: (filters, cursor) => [...adminKeys.works(), filters, cursor],
    workDetail: (workId) => [...adminKeys.works(), workId],
    genres: () => [...adminKeys.all, 'genres'],
    people: () => [...adminKeys.all, 'people'],
    peopleList: (q, cursor) => [...adminKeys.people(), { q, cursor }],
    personDetail: (personId) => [...adminKeys.people(), personId],
    logs: () => [...adminKeys.all, 'logs'],
    logsList: (filters, cursor) => [...adminKeys.logs(), filters, cursor],
    logDetail: (logId) => [...adminKeys.logs(), logId],
    toolLogs: () => [...adminKeys.all, 'toolLogs'],
    toolLogsList: (filters, cursor) => [...adminKeys.toolLogs(), filters, cursor],
    toolRuns: () => [...adminKeys.all, 'toolRuns'],
    toolRunsList: (toolName, cursor) => [...adminKeys.toolRuns(), toolName, cursor],
    toolNames: () => [...adminKeys.all, 'toolNames'],
    usersStats: (period) => [...adminKeys.all, 'usersStats', period],
    users: () => [...adminKeys.all, 'users'],
    usersList: (filters, page) => [...adminKeys.users(), 'list', filters, page],
    userDetail: (userId) => [...adminKeys.users(), 'detail', userId],
    userMessages: (userId, page) => [...adminKeys.users(), 'messages', userId, page],
    usersOverview: () => [...adminKeys.users(), 'overview'],
    settings: () => [...adminKeys.all, 'settings'],
    userLimits: (userId) => [...adminKeys.all, 'userLimits', userId],
};
